// extracted by mini-css-extract-plugin
export default {"requested_scopes_list":"authorize_requested_scopes_list__BzI3q","requested_scopes_list_item":"authorize_requested_scopes_list_item__useNj"};